import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { getCurrentWorkOrder } from '../../../selectors/admin/work-orders/work-orders';

/**
 * Call the route only if the currentWorkOrder is not null, otherwise redirects to /
 */
export const NewWorkOrderRouteGuard = ({ component: Component, ...rest }) => {
  if (rest.currentWorkOrder === null) {
    return <Redirect to="/" />;
  } else {
    return <Route {...rest} component={Component} />;
  }
};

function mapStateToProps(state) {
  return {
    currentWorkOrder: getCurrentWorkOrder(state),
  };
}

export default connect(mapStateToProps)(NewWorkOrderRouteGuard);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/NewWorkOrderRouteGuard.js